import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import PublicSite from "@/site/PublicSite";
import Blog from "@/site/Blog";
import BlogPost from "@/site/BlogPost";
import Login from "@/admin/Login";
import AdminApp from "@/admin/AdminApp";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--c-bg)]">
        <div className="font-heading text-2xl text-[var(--c-primary)] animate-pulse">শ্রুতি...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <SiteProvider>
                <PublicSite />
              </SiteProvider>
            }
          />
          <Route
            path="/blog"
            element={
              <SiteProvider>
                <Blog />
              </SiteProvider>
            }
          />
          <Route
            path="/blog/:slug"
            element={
              <SiteProvider>
                <BlogPost />
              </SiteProvider>
            }
          />
          <Route path="/admin/login" element={<Login />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminApp />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
